export var createElement = function (type) {
    return document.createElement(type);
};
